import LogoutComponent from './logout.component';

angular
	.module('app.logout', [])
	.component('appLogout', LogoutComponent);
